/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import { Popup as p } from "@progress/kendo-react-popup";
import { ZIndexContext as o } from "@progress/kendo-react-common";
const a = 12e3, u = 2e3, C = (r) => {
  const { children: i, width: c, dir: s, itemsCount: e, popupSettings: d } = r, n = t.useContext(o), m = n ? n + u : a;
  return /* @__PURE__ */ t.createElement(o.Provider, { value: m }, /* @__PURE__ */ t.createElement(
    p,
    {
      style: { width: c, direction: s },
      contentKey: e && e.join(),
      ...d
    },
    i
  ));
};
export {
  C as default
};
